export const CARD_BADGE_COLOR_OPTIONS = {
  stroll: 'stroll',
  rubber: 'rubber',
  gray: 'gray'
};

export const CARD_BADGE_COLORS = {
  stroll: 'bg-stroll-mid forest-dark-900',
  rubber: 'bg-rubber-light rubber-dark',
  gray: 'bg-passive secondary'
};
